<template>
    <div class="image-slideshow">
        <div v-if="images.length" class="image-slideshow__image">
            <img
                :src="images[isTabletSmall ? modalImagePosition : firstPosition].url"
                :alt="$t('alt.offer_details')"
                @click="openImageModal(firstPosition)"
            />

            <div v-if="images.length > 2 || (isTabletSmall && images.length > 1)" :class="leftArrowClass" @click="goToLeft()">
                <common-icon name="arrow-back" size="small"></common-icon>
            </div>
            <div v-if="isTabletSmall && images.length > 1" :class="rightArrowClass" @click="goToRight()">
                <common-icon name="arrow-forward" size="small"></common-icon>
            </div>
        </div>
        <div v-if="images.length > 1 && !isTabletSmall" class="image-slideshow__image">
            <img :src="images[secondPosition].url" :alt="$t('alt.offer_details')" @click="openImageModal(secondPosition)" />

            <div v-if="images.length > 2" :class="rightArrowClass" @click="goToRight()">
                <common-icon name="arrow-forward" size="small"></common-icon>
            </div>
        </div>

        <common-modal v-if="isImageModalOpen" width="large" @close="closeImageModal">
            <div class="image-slideshow__modal">
                <img :src="images[modalImagePosition].url" :alt="$t('alt.offer_details')" />
            </div>

            <div
                v-if="images.length > 1"
                :class="leftArrowClass"
                class="image-slideshow__modal--arrow-left"
                @click="goToLeftModal()"
            >
                <common-icon name="arrow-back" size="small"></common-icon>
            </div>

            <div
                v-if="images.length > 1"
                :class="rightArrowClass"
                class="image-slideshow__modal--arrow-right"
                @click="goToRightModal()"
            >
                <common-icon name="arrow-forward" size="small"></common-icon>
            </div>
        </common-modal>
    </div>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],

        props: {
            images: { type: Array, default: new Array() },
        },

        data: () => ({
            firstPosition: 0,
            secondPosition: 1,
            modalImagePosition: 0,
            isImageModalOpen: false,
        }),

        computed: {
            leftArrowClass() {
                return {
                    'image-slideshow__arrow': true,
                    'image-slideshow__arrow-left': true,
                    'image-slideshow__arrow-disabled':
                        this.isImageModalOpen || this.isTabletSmall ? this.isLeftModalDisabled : this.isLeftDisabled,
                }
            },

            rightArrowClass() {
                return {
                    'image-slideshow__arrow': true,
                    'image-slideshow__arrow-right': true,
                    'image-slideshow__arrow-disabled':
                        this.isImageModalOpen || this.isTabletSmall ? this.isRightModalDisabled : this.isRightDisabled,
                }
            },

            isLeftDisabled() {
                return this.firstPosition === 0
            },

            isRightDisabled() {
                return this.secondPosition === this.images.length - 1
            },

            isLeftModalDisabled() {
                return this.modalImagePosition === 0
            },

            isRightModalDisabled() {
                return this.modalImagePosition === this.images.length - 1
            },
        },

        methods: {
            goToLeft() {
                if (this.isTabletSmall) {
                    return this.goToLeftModal()
                }
                if (this.isLeftDisabled) {
                    return
                }
                this.firstPosition = this.firstPosition - 1
                this.secondPosition = this.secondPosition - 1
            },

            goToRight() {
                if (this.isTabletSmall) {
                    return this.goToRightModal()
                }
                if (this.isRightDisabled) {
                    return
                }
                this.firstPosition = this.firstPosition + 1
                this.secondPosition = this.secondPosition + 1
            },

            goToLeftModal() {
                if (this.isLeftModalDisabled) {
                    return
                }
                this.modalImagePosition = this.modalImagePosition - 1
            },

            goToRightModal() {
                if (this.isRightModalDisabled) {
                    return
                }
                this.modalImagePosition = this.modalImagePosition + 1
            },

            openImageModal(number) {
                this.isImageModalOpen = true
                this.modalImagePosition = number
            },

            closeImageModal() {
                this.isImageModalOpen = false
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/images/__image-slideshow.scss';
</style>
